<template>
  <div>
    <div ref="emblaRef" class="embla">
      <div class="embla__container">
        <slot />
      </div>
    </div>
    <div class="embla__buttons">
      <button aria-label="Previous slide" class="embla__button embla__button--prev" @click="scrollPrev"></button>
      <button aria-label="Next slide" class="embla__button embla__button--next" @click="scrollNext"></button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, defineProps } from 'vue';
import EmblaCarousel from 'embla-carousel';
import { EmblaOptionsType } from 'embla-carousel/esm';
import { templateRef } from '@vueuse/core';

interface Props {
  options?: EmblaOptionsType;
}

const props = withDefaults(defineProps<Props>(), {
  options: () => ({}),
});

const emblaRef = templateRef('emblaRef');
const emblaApi = ref<any>(null);

onMounted(() => {
  if (!emblaRef.value) return;

  const defaultOptions = {
    loop: true,
    align: 'start',
    slidesToScroll: 'auto',
  };

  const finalOptions = { ...defaultOptions, ...props.options };

  emblaApi.value = EmblaCarousel(emblaRef.value, finalOptions);
});

const scrollPrev = () => {
  emblaApi.value?.scrollPrev();
};

const scrollNext = () => {
  emblaApi.value?.scrollNext();
};
</script>

<style scoped lang="scss">
.embla {
  overflow: hidden;

  &__container {
    display: flex;
  }

  &__buttons {
    justify-content: center;
    display: flex;
    gap: 16px;
    margin-top: 48px;
  }

  &__button {
    background: no-repeat center center;
    width: 48px;
    height: 48px;
    border-radius: 48px;
    border: 1px solid var(--color-base-8);
    cursor: pointer;
  }

  &__button--prev {
    background-image: url("../../../assets/images/trustpilot/arrow-left.svg");
  }

  &__button--next {
    background-image: url("../../../assets/images/trustpilot/arrow-right.svg");
  }
}
</style>